export default __webpack_public_path__ + "static/media/logo_white.543061e5.png";